// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__HjRBn","Image":"Card_Image__2KxJM","Info":"Card_Info__3l5It","Title":"Card_Title__2iIyT","Description":"Card_Description__fN0Xy","Buttons":"Card_Buttons__2isjC"};